import { router } from 'expo-router';

import { useCreateProgram } from '@/api/hooks/programHooks';
import FormWrapper from '@/components/forms/FormWrapper';
import ProgramForm from '@/components/forms/ProgramForm';
import { useAuth } from '@/contexts/authContext';
import { useEndFlowModal } from '@/contexts/endFlowModalContext';
import { ProgramData } from '@/lib/validations/NpoOnboardingSchema';
import { i18n } from '@/utils/i18n';

const VolunteerEvent = () => {
  const { state } = useAuth();
  const { mutateAsync: createProgram, isPending } = useCreateProgram();
  const { showSuccess } = useEndFlowModal();

  const submitFn = async (data: ProgramData) => {
    const npoId = state.signUpData?.loginEmail?.npoId;

    try {
      if (!npoId) {
        console.error('npoId is missing');
        return;
      }

      createProgram(
        {
          name: data.name,
          title: data.title ?? data.name,
          description: data.description,
          programDate: data.programDate,
          nonProfitOrgId: npoId,
          budget: data.budget,
          address: data.address,
          location: data.location
        },
        {
          onSuccess: () => {
            showSuccess({
              title: i18n.t('end_flow.success_title'),
              message: i18n.t('profile.create_form.program_success_message')
            });
            router.back();
          },
          onError: (e) => {
            console.error(e);
          }
        }
      );
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <FormWrapper scrollEnable={true}>
      <ProgramForm isLoading={isPending} showDoneButton doneLabel={i18n.t('mix.submit')} onDone={submitFn} />
    </FormWrapper>
  );
};

export default VolunteerEvent;
